
    export default {
      mounted() {
        const userId = this.el.dataset.userId;
        this._limit = parseInt(this.el.dataset.recentLimit, 10) || 3;
        this._key = `gt:recent-orgs:${userId}`;
        this._ids = [];
        try {
          const raw = window.localStorage.getItem(this._key);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) this._ids = parsed.filter((x) => typeof x === "string");
          }
        } catch (_e) {
          // localStorage unavailable (private mode, disabled, quota): treat as empty.
        }

        this.pushEvent("recents_loaded", { ids: this._ids });

        this._onClick = (e) => {
          const target = e.target.closest("[data-org-public-id]");
          if (!target || !this.el.contains(target)) return;
          const publicId = target.dataset.orgPublicId;
          if (!publicId) return;
          const next = [publicId, ...this._ids.filter((x) => x !== publicId)].slice(0, this._limit);
          this._ids = next;
          try {
            window.localStorage.setItem(this._key, JSON.stringify(next));
          } catch (_e) {}
        };
        // Capture phase so we run before LiveView's link navigation handler.
        this.el.addEventListener("click", this._onClick, true);
      },
      destroyed() {
        if (this._onClick) this.el.removeEventListener("click", this._onClick, true);
      },
    };
  